import { IMAGE, VIDEO, AUDIO, FONT, OTHER, HEIC, PDF } from '../constants/fileTypes';
import SUPPORTED_FONTS from '../constants/fonts';

function parseMetaData(metaData) {
  try {
    if (typeof metaData !== 'string') {return metaData || {};}

    return JSON.parse(metaData);
  } catch (e) {
    return metaData || {};
  }
}

function getTypeFromFileName({ filename }) {
  try {
    if (!filename) {return OTHER;}

    const fileExtensionMatch = filename.match(/\.[0-9a-z]+$/i);

    if (!fileExtensionMatch || !fileExtensionMatch.length) {return OTHER;}

    const fileExtension = fileExtensionMatch[0].toLowerCase();

    if (SUPPORTED_FONTS.includes(fileExtension)) {return FONT;}

    if (['.mts'].includes(fileExtension)) {return VIDEO;}

    if (fileExtension === '.pdf') {return PDF;}

    return OTHER;
  } catch (e) {
    return OTHER;
  }
}

export default function getTypeFromAsset(
{ metaData, filename })
{
  const { type } = parseMetaData(metaData);

  if (!type) {return getTypeFromFileName({ filename });}

  if (type.includes('image/heic')) {return HEIC;}

  if (type.includes('image/')) {return IMAGE;}

  if (type.includes('video/')) {return VIDEO;}

  if (type.includes('audio/')) {return AUDIO;}

  if (type.includes('font/')) {return FONT;}

  if (type.includes('application/pdf')) {return PDF;}

  return OTHER;
}